(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sizeGuideInit) return;
    window.__sizeGuideInit = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var openButton = target.closest('[data-size-guide-open]');
      if (openButton) {
        var wrapper = openButton.closest('.size-guide');
        var dialog = wrapper && wrapper.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      var closeButton = target.closest('[data-size-guide-close]');
      if (closeButton) {
        var parentDialog = closeButton.closest('dialog');
        if (parentDialog) parentDialog.close();
        return;
      }

      // Click on the dimmed backdrop (outside the panel) closes it
      if (target.matches('dialog.size-guide__dialog')) target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-tryon"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('video-tryon')) return;

    class VideoTryon extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        // Listeners live on this element, so they survive the theme re-rendering the variant picker.
        this.addEventListener('click', (event) => this._onClick(event));
        // 'close' doesn't bubble, so listen in the capture phase to pause the video on any close.
        this.addEventListener('close', () => {
          const video = this.querySelector('video');
          if (video) video.pause();
        }, true);
      }

      get _dialog() { return this.querySelector('dialog'); }

      get _variants() {
        try { return JSON.parse(this.dataset.variants || '[]'); } catch (e) { return []; }
      }

      _onClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const dialog = this._dialog;

        if (target.closest('[data-tryon-open]')) return this._open();
        if (target.closest('[data-tryon-close]')) { if (dialog) dialog.close(); return; }

        const pill = target.closest('[data-tryon-option]');
        if (pill) return this._pick(pill);

        if (target.closest('[data-tryon-add]')) return this._add();

        // Click on the dimmed backdrop closes the pop-up
        if (dialog && target === dialog) dialog.close();
      }

      _open() {
        const dialog = this._dialog;
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const msg = this.querySelector('[data-tryon-msg]');
        if (msg) msg.hidden = true;
        dialog.showModal();
        this._sync();
        const video = dialog.querySelector('video');
        if (video) {
          const played = video.play();
          if (played && typeof played.catch === 'function') played.catch(function () {});
        }
      }

      _pick(pill) {
        const group = pill.closest('.video-tryon__pills');
        if (group) {
          group.querySelectorAll('[data-tryon-option]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        }
        pill.setAttribute('aria-pressed', 'true');
        this._sync();
      }

      _selection() {
        const selection = [];
        this.querySelectorAll('[data-tryon-option][aria-pressed="true"]').forEach((b) => {
          selection[Number(b.dataset.tryonOption)] = b.dataset.tryonValue;
        });
        return selection;
      }

      _match(selection) {
        const variants = this._variants;
        if (!this.querySelector('[data-tryon-option]')) return variants[0];
        return variants.find((v) => v.options.every((o, i) => o === selection[i]));
      }

      _sync() {
        const selection = this._selection();
        const variant = this._match(selection);
        const variants = this._variants;
        const addButton = this.querySelector('[data-tryon-add]');
        const price = this.querySelector('[data-tryon-price]');

        if (price && variant) price.textContent = variant.price;

        if (addButton) {
          const ok = !!variant && variant.available;
          addButton.disabled = !ok;
          addButton.textContent = ok ? this.dataset.labelAdd : this.dataset.labelSoldOut;
        }

        // Strike through option values that can't currently be bought with the other chosen options
        this.querySelectorAll('[data-tryon-option]').forEach((pill) => {
          const test = selection.slice();
          test[Number(pill.dataset.tryonOption)] = pill.dataset.tryonValue;
          const buyable = variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          pill.classList.toggle('is-unavailable', !buyable);
        });
      }

      async _add() {
        const variant = this._match(this._selection());
        const addButton = this.querySelector('[data-tryon-add]');
        const msg = this.querySelector('[data-tryon-msg]');
        const dialog = this._dialog;
        if (!variant || !variant.available || !addButton) return;

        addButton.disabled = true;
        if (msg) msg.hidden = true;

        try {
          const body = new FormData();
          body.append('id', String(variant.id));
          body.append('quantity', '1');

          // Ask Shopify for the cart drawer's HTML so it can refresh itself, like the normal Add to cart does
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) body.append('sections', sectionIds.join(','));

          const url = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
          const response = await fetch(url, { method: 'POST', body: body, headers: { Accept: 'application/json' } });
          const data = await response.json();

          if (data.status) {
            if (msg) {
              msg.textContent = data.description || data.message || 'Sorry, this could not be added to your cart.';
              msg.hidden = false;
            }
            addButton.disabled = false;
            return;
          }

          if (dialog) dialog.close();

          try {
            const events = await import('@theme/events');
            this.dispatchEvent(new events.CartAddEvent({}, String(variant.id), {
              source: 'product-form-component',
              itemCount: 1,
              productId: this.dataset.productId,
              sections: data.sections
            }));
          } catch (e) {
            window.location.href = '/cart';
          }
        } catch (error) {
          if (msg) {
            msg.textContent = 'Sorry, something went wrong. Please try again.';
            msg.hidden = false;
          }
        } finally {
          this._sync();
        }
      }
    }

    customElements.define('video-tryon', VideoTryon);
  })();
  } catch(e) { console.error(e); }
})();

})();
